module.exports = __webpack_public_path__ + "static/speed-science-black-cfcdcd7a09eca9e5326da0f44f5073b1.png";